export default function replaceLast(
  source: string,
  what: string,
  replacement: string,
) {
  if (!source) {
    return;
  }
  if (!source.includes(what)) {
    return source;
  }
  const pcs = source.split(what);
  const lastPc = pcs.pop();
  return pcs.join(what) + replacement + lastPc;
}
